export default __webpack_public_path__ + "assets/images/21e2e7c0d1a5b6fabdee4c80da594aa6.png";